module.exports = __webpack_public_path__ + "images/fdb8472626aeedfd53cec83bf17f209d.jpg";